export { default as PeoplePage } from "./PeoplePage";
